export const getBonusApprovals = (state) => {
  return state.bonusApprovals;
};

export const getUserBonusMonthId = (state) => {
  const { userBonusMonthId } = getBonusApprovals(state);
  return userBonusMonthId;
};

export const getBonusMonth = (state) => {
  const { bonusMonth } = getBonusApprovals(state);
  return bonusMonth;
};

export const getSupervisorId = (state) => {
  const { supervisorId } = getBonusApprovals(state);
  return supervisorId;
};

export const getUserId = (state) => {
  const { userId } = getBonusApprovals(state);
  return userId;
};

export const getUserIdState = (state) => {
  const { userIdState } = getBonusApprovals(state);
  return userIdState;
};
